import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["counter", "checkbox"];
  static values = {
    announced: {
      type: String,
      default: "of 3 selected",
    },
  };

  declare counterTarget: HTMLElement;
  declare checkboxTargets: HTMLInputElement[];
  declare announcedValue: string;

  connect() {
    this.updateCounter();
  }

  updateCounter() {
    const selectedCount = this.checkboxTargets.filter(
      (checkbox) => checkbox.checked
    ).length;
    this.counterTarget.innerText = `${selectedCount} ${this.announcedValue}`;
  }
}
